import { editStorageObject } from "../../../../../app/state/storageObjectSlice/actions/actions";
import { setSelectedObjectId } from "../../../../../app/state/storageObjectSlice/slice";
import { INIT_SKILL_VALUE } from "../../../../../features/Skills/constants";
import {
  clearSkillValue,
  setSkillValue,
} from "../../../../../features/Skills/redux/slice";
import { SkillValue } from "../../../../api/instances/skillsApi/types";
import type { ServiceHandler } from "./storageHandlers";

export const SkillsService: ServiceHandler = {
  async onCreate(listenerApi, normalized, meta) {
    if (normalized.value === null) {
      return;
    }
    try {
      listenerApi.dispatch(clearSkillValue());
      const updatedValue: SkillValue = {
        skill_object: {
          ...INIT_SKILL_VALUE.skill_object,
          friendly_name: normalized?.friendly_name,
        },
      };

      await listenerApi.dispatch(
        editStorageObject({
          id: normalized.id,
          name: normalized.friendly_name,
          value: updatedValue,
          service: meta.arg.service,
        }),
      );
      listenerApi.dispatch(setSkillValue(updatedValue));
    } catch (e) {
      console.error("Ошибка при создании диалога", e);
    }
  },
  async onSelect(listenerApi, id, value) {
    if (id === null || value === null) return;
    try {
      listenerApi.dispatch(clearSkillValue());
      listenerApi.dispatch(setSkillValue(value as SkillValue));
    } catch (e) {
      console.error("Нет объекта с таким ID");
    }
  },
  // async onDelete(listenerApi, id, value) {
  //   if (id === null || value === null) return;
  //   try {
  //     const thread_id = (value as DialogValue)?.dialog_object?.thread_ref;
  //     if (thread_id) {
  //       listenerApi.dispatch(clearMessages());
  //       await deleteThread(thread_id);
  //     }
  //   } catch (e) {
  //     console.error("Нет объекта с таким ID");
  //   }
  // },
};
